import React from "react";
import { Helmet } from "react-helmet";

export default function Eula() {
  return (
    <main style={{ maxWidth: 900, margin: "48px auto", padding: "0 20px", lineHeight: 1.6 }}>
      <Helmet>
        <title>End-User License Agreement (EULA) | LSSI Fin</title>
        <meta name="description" content="End-User License Agreement for the LSSI Fin QuickBooks Online integration." />
      </Helmet>

      <h1>End-User License Agreement (EULA)</h1>
      <p style={{ color: "#555" }}>Last updated: November 2025</p>

      <p>
        This End-User License Agreement (“Agreement”) is between you and <b>LSSI Fin</b> (“we,” “us,”
        or “our”) and governs your use of the LSSI Fin application and related services (the “App”).
      </p>

      <h2>1. Acceptance</h2>
      <p>By using the App (including connecting it to QuickBooks Online), you agree to this Agreement.</p>

      <h2>2. License Grant</h2>
      <p>We grant a limited, non-exclusive, non-transferable, revocable license for your internal business use.</p>

      <h2>3. Your Data & QBO Access</h2>
      <ul>
        <li>Your data remains yours; we access QBO data only to provide requested features.</li>
        <li>You may revoke access at any time from the App or your Intuit account.</li>
        <li>You’re responsible for the accuracy and legality of data you share.</li>
      </ul>

      <h2>4. Security</h2>
      <p>We use HTTPS and store OAuth tokens securely, but no method is 100% secure.</p>

      <h2>5. Restrictions</h2>
      <ul>
        <li>No reverse engineering or scraping outside normal App use.</li>
        <li>No sharing/sublicensing/reselling.</li>
        <li>No unlawful use or violation of third-party terms (including Intuit).</li>
      </ul>

      <h2>6. Disclaimers</h2>
      <p>THE APP IS PROVIDED “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTIES OF ANY KIND.</p>

      <h2>7. Limitation of Liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, WE ARE NOT LIABLE FOR INDIRECT/CONSEQUENTIAL DAMAGES.
        TOTAL LIABILITY WILL NOT EXCEED FEES PAID (IF ANY) FOR THE PRIOR 3 MONTHS.
      </p>

      <h2>8. Term & Termination</h2>
      <p>We may suspend/terminate for cause; you can stop using the App anytime.</p>

      <h2>9. Changes</h2>
      <p>We may update this Agreement; continued use means acceptance.</p>

      <h2>10. Contact</h2>
      <p>Questions? <a href="mailto:info@lssi-fin.com">info@lssi-fin.com</a></p>
    </main>
  );
}